// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__AISRJ","facebook":"styles_facebook__aQXIc","apple":"styles_apple__FITBB"};